import { Component } from '@angular/core';

import { CarouselComponent } from "../carousel/carousel.component";
import { PRIMENG_MODULES } from '../../shared/primeng-imports';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { Router } from '@angular/router';
@Component({
  selector: 'app-login',
  standalone: true,
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  imports: [...PRIMENG_MODULES, CarouselComponent]
})
export class LoginComponent {

  constructor(
    private msalService: MsalService,
    private router: Router,
  ) { }
  async ngOnInit() {
    await this.msalService.instance.initialize();
    const currentAccount = this.msalService.instance.getAllAccounts();
    if (currentAccount.length > 0) {
      this.router.navigate(['/']);
    }

  }
  login() {
    sessionStorage.clear();
    this.msalService.loginRedirect();

  }
}
